<!-- 
	AdminNotes
	props: User
  role: Admin
	Called by @/views/AdminUser to view and create notes for app Users
-->

<template>
	<div
		class="
      admin-notes
      w-6/6
      my-6
      mx-auto
      border
      rounded-xl
      py-8
      bg-gray-100
      text-black
    "
	>
		<div class="w-4/6 mx-auto flex justify-between px-2 items-center">
			<div class="font-bold">Customer Service Notes</div>
			<div class="">
				<i
					v-if="this.create === false"
					class="fas fa-plus"
					@click="this.create = true"
				></i>
				<i
					v-if="this.create === true"
					class="far fa-times-circle"
					@click="this.create = false"
				></i>
				<div v-else></div>
			</div>
		</div>
		<div v-if="error" class="alert">
			<Alert>{{ error }}</Alert>
		</div>
		<div v-if="this.create">
			<div class="form-group my-2">
				<textarea
					class="w-4/6 text-black p-2 bg-gray border border-gray-400 rounded-xl"
					v-model="form.note"
					placeholder="Write your note here"
					required
				/>
			</div>
			<div v-if="this.form.note" class="-mt-6">
				<CustomButton @click="postNote()">Add Note</CustomButton>
			</div>
		</div>

		<div v-if="loaded">
			<div v-for="note in notes" v-bind:key="note.id">
				<div
					class="
            note-cont
            my-4
            mx-auto
            border
            rounded-xl
            border-gray-400
            w-4/6
            py-4
            px-2
          "
				>
					<div class="pb-2 text-left">
						{{ note.Text }}
						<hr class="border-gray-400" />
					</div>
					<div class="text-sm text-right">{{ note.CreatedByEmail }}</div>
					<div class="text-sm text-right">{{ note.DateCreated }}</div>
				</div>
			</div>
		</div>
		<div v-else class="my-4">
			<Loading />
		</div>
	</div>
</template>
<script>
	import { useRoute } from "vue-router";

	import { getAdminUserNotes, postAdminUserNotes } from "@/utils/api";

	import Alert from "@/components/Alert";
	import CustomButton from "@/components/CustomButton";
	import Loading from "@/components/Loading";

	import store from "../store";

	export default {
		name: "AdminNotes",
		components: {
			Alert,
			CustomButton,
			Loading,
		},
		props: ["user"],
		data() {
			return {
				loaded: false,
				notes: null,
				create: false,
				form: {
					note: "",
				},
				error: null,
			};
		},
		async created() {
			// get admin notes based off UserId params passed from admin user list
			const route = useRoute();

			const data = route.params.User_Id;
			const token = this.$props.user.token;

			const res = await getAdminUserNotes(token, data);

			this.notes = res.Data;
			this.loaded = true;
		},
		methods: {
			async postNote() {
				// create new note for user
				const userId = this.$route.params.User_Id;

				const query = this.$props.user.adminData;

				const userProfile = query.find((o) => o.UserId === userId);
				const index = query.indexOf(userProfile);

				const createdByEmail = this.$props.user.data.email;

				try {
					const noteData = {
						createdByEmail: createdByEmail,
						text: this.form.note,
					};

					const res = await postAdminUserNotes(userId, noteData);

					if (res.Success) {
						this.create = false;
						this.form.note = "";
						this.error = "Note has been sent.\nRefresh the page to view";
					}
				} catch (err) {
					console.log(err);
					store.dispatch("setError", err);
				}
			},
		},
	};
</script>
